import { memo } from "react";

import X from "../../../../../public/assets/icon/sns/x.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const XIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: X });
	return <Icon />;
};

export default memo(XIcon);
